import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import {Location} from '@angular/common';
@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
	private sub: any;
	private id: number;
	private currentUser = {};
	private users= [{id:1,img:"assets/img/avatar6.png",name:"Penelope Thornton",organization:"Initial commit",designation:"Bootstrap Admin",team:"master",country:"China"}
      ,{id:2,img:"assets/img/avatar5.png",name:"Justine Myranda",organization:"Left sidebar adjusments",designation:"Back-end Manager",team:"develop",country:"Norway"}
      ,{id:3,img:"assets/img/avatar4.png",name:"Benji Harper",organization:"Main structure markup",designation:"CLI Connector",team:"develop",country:"Pakistan"}
      ,{id:4,img:"assets/img/avatar3.png",name:"Sherwood Clifford",organization:"Topbar dropdown style",designation:"Bootstrap Admin",team:"master",country:"France"}
      ,{id:5,img:"assets/img/avatar3.png",name:"Sherwood Clifford",organization:"Topbar dropdown style",designation:"Bootstrap Admin",team:"master",country:"France"}	
					];

  constructor( public route: ActivatedRoute,
              public mobileNav: MobileNavService,
              public _location: Location,
            ) { }

  onClickMe() {
    this.mobileNav.showSideNav();
    }

  ngOnInit() {
  	this.sub = this.route.params.subscribe(params => {
       	this.id = params["id"];
			  this.currentUser = this.users.filter(x => x.id == this.id)[0];       											
    });
  }
  backBtnClick(){
    this._location.back();
  }

}